import { Injectable } from '@angular/core';
import { isNil } from 'lodash';

import { PageConstant } from 'src/app/constants';
import { Operator } from 'src/app/models';
import { NavigationItem } from 'src/app/pages/pos-manager/main/main.page';

type NavigationItems = Partial<NavigationItem>[];

@Injectable()
export abstract class ManagerMenuAbstractClass {
  constructor() {}

  protected initNavigationItems(
    staff: Operator,
    canAccessReportingPage: boolean
  ): NavigationItems {
    let filterNavigationItems: NavigationItems = [];

    if (staff) {
      filterNavigationItems = PageConstant.POS_MANAGER_MENU_NAV_ITEMS.filter(
        (item) =>
          isNil(item.permissionKey) || staff.permissions[item.permissionKey]
      );

      if (canAccessReportingPage) {
        filterNavigationItems.push({
          icon: {
            svgIcon: '../../assets/icon/file-chart-pie.svg'
          },
          name: 'POS Dashboard',
          routerLink: '/' + PageConstant.POS_MANAGER_REPORTING_PAGE
        });
      }
    }

    return filterNavigationItems;
  }
}
